import { Download } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import { eReportNhapHocActionsObj } from "../../action-types/report/IReportNhapHocActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const reportNhapHocActions = {
  ...generateActions(eReportNhapHocActionsObj, "REPORT_NHAP_HOC"),
  ...generateActionForKey(
    eReportNhapHocActionsObj,
    "REPORT_NHAP_HOC",
    "EXPORT_EXCEL_BAO_CAO_SUCCESS",
    (data: any) => {
      Download.Excel(data, "bao_cao_tong_hop_nhap_hoc.xlsx");
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eReportNhapHocActionsObj,
    "REPORT_NHAP_HOC",
    "EXPORT_EXCEL_BAO_CAO_ERRR",
    (m: any) => {
      NotifyHelper.Error(m);
    }
  ),
};
